import { useCallback, useState } from 'react'
import { current as getCurrentBreakpoint, values } from '../styles/breakpoints'
import useDebouncedCallback from './useDebouncedCallback'
import useWindowResize from './useWindowResize'

const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(getCurrentBreakpoint())
  const onResize = useCallback(() => {
    const newBreakpoint = getCurrentBreakpoint()
    setBreakpoint(newBreakpoint)
  }, [])
  useWindowResize(useDebouncedCallback(onResize, 200), true)
  return {
    breakpoint,
    width: values[breakpoint]
  }
}

export default useBreakpoint
